import { WorkflowStepCode } from '@exam-management/graphql';

export interface CommentItem {
  id: string;
  taskId: string;
  content: string;
  createdAt: Date;
  updatedAt: Date;
  user: {
    firstname: string;
    lastname: string;
    email: string;
    image: string | null;
  };
}

// This is the picked wfl step code for Review Workflow only
// Casing mightn't be the same as the convention as it's just an attempt to replicate the original codegen
export const QSetReviewWorkflowStepCodeObject = {
  QsetReviewTodo: WorkflowStepCode.ReviewQsetTodo,
  QsetReviewInReview: WorkflowStepCode.ReviewQsetInReview,
  QsetReviewReviewed: WorkflowStepCode.ReviewQsetReviewed,
  QsetReviewDone: WorkflowStepCode.ReviewQsetDone,
} as const;

export type QSetReviewWorkflowStepCode =
  (typeof QSetReviewWorkflowStepCodeObject)[keyof typeof QSetReviewWorkflowStepCodeObject];

export const QuestionCreationWorkflowStepCodeObject = {
  QuestionCreationTodo: WorkflowStepCode.QuestionCreationTodo,
  QuestionCreationInProgress: WorkflowStepCode.QuestionCreationInProgress,
  QuestionCreationDone: WorkflowStepCode.QuestionCreationDone,
} as const;
export type QuestionCreationWorkflowStepCode =
  (typeof QuestionCreationWorkflowStepCodeObject)[keyof typeof QuestionCreationWorkflowStepCodeObject];

export enum QuestionReviewWorkflowStepCode {
  QuestionReviewTodo = WorkflowStepCode.QuestionReviewTodo,
  QuestionReviewInReview = WorkflowStepCode.QuestionReviewInReview,
  QuestionReviewReviewed = WorkflowStepCode.QuestionReviewReviewed,
  QuestionReviewDone = WorkflowStepCode.QuestionReviewDone,
}
